import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setDecompositionTreeMinMaxMetric as setDecompositionTreeMinMaxMetricDiagram, getDecompositionTreeMinMaxMetric as getDecompositionTreeMinMaxMetricDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type MinMaxProps = ApiMethodBase & {
    min: number;
    max: number;
};

export const setDecompositionTreeMinMaxMetric = ({
    min,
    max,
}: MinMaxProps) => {
    setDecompositionTreeMinMaxMetricDiagram({min, max});
};


export const getDecompositionTreeMinMaxMetric = (): MinMaxProps => getDecompositionTreeMinMaxMetricDiagram();
